import { Select, SelectContent, SelectTrigger, SelectItem, SelectValue, Icon } from '@shopflo/ui'
import { AmountType, CouponType, DiscountApplyToType, EntitledCatalogueSelectionMode } from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import EntitledProductsList from './EntitledProductsList'
import { DiscountFieldPaths } from 'src/lib/types/discountsV2'
import DiscountInfoText from '../../../common/DiscountInfoText'
import DiscountPricingInput from '../../../common/DiscountPricingInput'
import { useLocale } from 'src/lib/hooks/useLocal'

const AmountOffProductsPricing = () => {
  const {
    state: { entitlement, uiConfig, errors },
    actions: { setFormState }
  } = useDiscountForm()
  const { t } = useLocale()

  if (entitlement.type !== CouponType.AMOUNT) return null

  const { applyTo } = entitlement

  const handleTargetChange = (value: string) => {
    let applyTo = DiscountApplyToType.SPECIFIC_PRODUCTS

    if (value === 'specific_products') {
      applyTo = DiscountApplyToType.SPECIFIC_PRODUCTS
    } else if (value === 'specific_collections') {
      applyTo = DiscountApplyToType.SPECIFIC_COLLECTIONS
    }

    setFormState({
      entitlement: {
        ...entitlement,
        applyTo,
        entitledCatalogue: [
          {
            quantity: 1,
            entities: [],
            selectionMode: EntitledCatalogueSelectionMode.ANY
          }
        ],
        excludedCatalogue: [],
        metaData: {
          ...entitlement.metaData,
          entitledCatalogue: [],
          excludedCatalogue: []
        }
      }
    })
  }

  return (
    <div className='flex flex-col w-full gap-3'>
      <h3 className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.set_discount')}</h3>
      <div className='flex gap-3 w-full'>
        <div className='flex-1'>
          <DiscountPricingInput error={errors[DiscountFieldPaths.CONCESSION_AMOUNT]} />
        </div>

        <div className='flex-1'>
          <Select
            value={applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS ? 'specific_collections' : 'specific_products'}
            onValueChange={handleTargetChange}
          >
            <SelectTrigger
              id='amount-off-target-trigger'
              className='w-full h-9 rounded-lg opacity-100 cursor-default text-zinc-800 bg-white'
              showCaret
            >
              <div className='p-1 truncate'>
                {applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS
                  ? t('discounts_v2.on_specific_collections')
                  : t('discounts_v2.on_specific_products')}
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem id='target-specific-products' value='specific_products'>
                {t('discounts_v2.on_specific_products')}
              </SelectItem>
              <SelectItem id='target-specific-collections' value='specific_collections'>
                {t('discounts_v2.on_specific_collections')}
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <DiscountInfoText
        text={t('discounts_v2.amount_off_products_info')}
        show={entitlement.entitledCatalogue?.some(group => group?.entities?.length > 0)}
      />
      {(applyTo === DiscountApplyToType.SPECIFIC_PRODUCTS || applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS) && (
        <EntitledProductsList />
      )}
    </div>
  )
}

export default AmountOffProductsPricing
